import $ from 'jquery'

$(document).ready(function() {
	if (!$('body').hasClass('home')) {
		return
	}

	//Banner
	const $homeBannerSlick = $('.home-banner-slides')
	const homeBannerArg = {
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000
	}
	$homeBannerSlick.slick(homeBannerArg)

	//News
	const hasCalendar = $('.news-events-block').hasClass('has-calendar')
	const $homeNewsSlick = $('.news-items-inner-wrapper')
	const homeNewsArg = {
		infinite: true,
		slidesToShow: hasCalendar ? 3 : 4,
		slidesToScroll: hasCalendar ? 3 : 4,
		autoplay: true,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	}
	$homeNewsSlick.slick(homeNewsArg)

	//Welcome
	const $welcomGallerySlick = $('.welcom-gallery')
	const welcomGalleryArg = {
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000
	}
	$welcomGallerySlick.slick(welcomGalleryArg)
})
